/**
 * @Desription: 值转换管理
 * @Author: netstar.sjj
 * @Date: 2021-10-21 11:05:00
 * @class valueConverManager
*/
declare const window:any;
namespace valueConverManager{
    //根据时间戳获取日期 1544767009477 -> 2018/12/14
    export function getDateTimeStringByTimestamp(_value:any, options:any) {
        /**
         * value: string/number 要转化为时间字符串的时间戳 例如：1544767009477
         * options:{
         * 		format:'YYYY/MM/DD'  //默认的格式 moment标准格式
         * 		defaultFormat:'YYYY/MM/DD HH:mm:ss'
         * }
        */
        let i18n:any = window.language.converDate;
        let isConvert:boolean = false;//默认不对值进行转换
        let value:any = _value;//默认值为空
        if (value === null || typeof (value) == 'undefined') {
            value = '';
        }
        switch (typeof (value)) {
            case 'string':
                if (value) {
                    //值为字符串类型并且存在
                    value = parseInt(value);
                    if (isNaN(value)) {
                        isConvert = false;
                    } else {
                        isConvert = true;
                    }
                }
                break;
            case 'number':
                if (value != 0) {
                    //值为数值类型但值为0 此处不应该 排除0 但因为存在获取类型值转换问题所以暂定方案需要过滤0
                    isConvert = true;
                } else {
                    //如果格式化结果是只要时间不要年月日，则为0也是正常赋值
                    if (options.format == 'HH:mm:ss') {
                        isConvert = true;
                    } else {
                        isConvert = false;
                    }
                }
                break;
            default:
                if (window.debugerMode) {
                    console.error(window.language.timeStampConverErrorMsg + typeof (value));
                    console.error(value);
                }
                break;
        }
        if (isConvert) {
            //可以对值进行转换
            let defaultFormat:string = options.defaultFormat ? options.defaultFormat : i18n.defaultDateFormat;
            let format:any = options.format ? options.format : defaultFormat; //如果没有定义转换，则默认转换格式为年-月-日
            if (typeof (format) != 'string') {
                format = 'YYYY/MM/DD';
            }
            value = window.moment(value).format(format);
        } else {
            if (value === '') {
                // value是空时不处理 lyw
            } else {
                if (window.debugerMode) {
                    console.error(window.language.timeStampConverFailMsg + _value);
                }
                value = i18n.errorDateValue;
            }
        }
        return value;
    }
    //根据数字获取货币文本 21556.3 -> $21,556.30
    export function getMoneyStringByNumber(_value:any, options:any, isTotal?:boolean) {
        /**
         *  value: number 要转化为货币字符串的数字 21556.3
         * 	options:{
         * 		places:		//小数位数 默认2位
         * 		symbol:		//标识符 默认$
         * 		thousand:	//分隔符 默认
         * 		decimal:	//小数点 默认显示小数点
         * }
        */
        let i18n:any = window.language.converDate;
        if (_value === null || _value === '') {
            return '';
        }
        if (typeof (isTotal) != 'boolean') { isTotal = false; }
        let number:any = _value || 0;
        let places:number = options.places;
        let symbol:string = options.symbol;
        let thousand:string = options.thousand;
        let decimal:string = options.decimal;

        if (isTotal === true) {
            symbol = options.totalSymbol;
        }

        places = !isNaN(places = Math.abs(places)) ? places : 2;
        symbol = symbol !== undefined ? symbol : i18n.moneySymbol;
        thousand = thousand || ",";
        decimal = decimal || ".";
        let negative:string = number < 0 ? "-" : "";
        let i:any = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "";
        let j:any = i.length > 3 ? (i.length) % 3 : 0;
        let returnValue = symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
        return returnValue;
    }
    //根据数字获取格式化后的文本数字
    export function getFormatNumberStringByNumber(_value:any, options:any) {
        /**
         *  value: number 要转化为格式化字符串的数字 21556.3
         * 	options:{
         * 		places:		//小数位数 默认3位
         * 		thousand:	//分隔符 默认
         * }
         */
        let _options:any = window.jQuery.extend(true, {}, options);
        _options.symbol = '';
        _options.decimal = '.';
        return this.getMoneyStringByNumber(_value, _options);
    }
    //获取字典数据
    export function getDictionaryByDictionary(_value:any, options:any,colors:any) {
        /**
         *  value: number 要转化为格式化字符串的数字 21556.3
         * 	options:{
                0:'nan',1:'nv'
         * }
         */
        /*  
        _value 当前值
        _format 字典值 如{'male':'1','female':'2'}
     */
        colors = typeof(colors)=='object' ? colors : {};
        let dictionaryValue:string = '';
        let isSingle:any = true; //默认读取单个字典
        if (typeof (_value) == 'string') {
            //是字符串类型并且还有逗号分割 认为要处理多个字典显示
            if (_value.indexOf(',') > -1) {
                isSingle = false;
            }
        }
        if (isSingle === true) {
            window.jQuery.each(options, function (key:any, value:any) {
                if (key == _value) {
                    //找到相对应的值终止查找
                    dictionaryValue = value;
                    return false;
                }
            });
            if(dictionaryValue){
                let reg:any = /[switch]/;
                if (!reg.test(dictionaryValue)) {
                    //如果字典值里面还有switch则输出标签
                    const labelClassStr = colors[_value] ? colors[_value] : 'label-state label-state-default';
                    dictionaryValue = '<label class="'+labelClassStr+'">' + dictionaryValue + '</label>';
                }
            }
        } else {
            let dataArray:any = _value.split(',');
            for (let dataI = 0; dataI < dataArray.length; dataI++) {
                let labelClassStr:any = colors[dataArray[dataI]] ? colors[dataArray[dataI]] : 'label-state label-state-color8';
                if(window.jQuery.isEmptyObject(colors)){
                    labelClassStr = 'label-state label-state-default';
                }
               
                dictionaryValue += '<label class="'+labelClassStr+'">' + options[dataArray[dataI]] + '</label>';
            }
        }
        return dictionaryValue;
    }
    //获取列表数据通过树结构 
    export function getListByTreeData(rows:any,level?:number,isCountFirstNode?:boolean){
        let treeRows:any = [];
        isCountFirstNode = typeof(isCountFirstNode)=='boolean' ? isCountFirstNode : true;//默认计算第一级节点，如果配置了不计算则不计算
        let expandLevel:number = Number(level) ? level : 0;
        let expandOpen:boolean = true;
        if(expandLevel == -1){
            expandOpen = false;
        }
        function formatTreeData(array:any,levelIndex:number,isHasParent:boolean,currentRowIndex?:number) {
            if (!window.jQuery.isArray(array)) { return; }
            let isOpen:boolean = true;//是否显示
            let isExpand:boolean = expandOpen;//当前是父节点是否展开状态
            for (let rowI = 0; rowI < array.length; rowI++) {
                array[rowI].netstarLevel = levelIndex;
                array[rowI].netstarOpen = isOpen;
                array[rowI].netstarExpand = isExpand;
                if(isExpand === false){
                    if(levelIndex === 0){
                        array[rowI].netstarOpen = true;
                    }else{
                        array[rowI].netstarOpen = false;
                    }
                }
                array[rowI]['NETSTAR-AUTOSERIES'] = rowI+1;
                if(currentRowIndex > -1){
                    array[rowI]['NETSTAR-AUTOSERIES'] = (currentRowIndex+1) + '-'+(rowI+1);
                }
                let isChildren:boolean = true;
                if (!window.jQuery.isArray(array[rowI].children)) {
                    isChildren = false;
                } else {
                    if (array[rowI].children.length == 0) {
                        isChildren = false;
                    }
                }

                //计算PADDING-LEFT
                let leftNum:number = levelIndex * 15 + 15;
                if(isCountFirstNode === false){leftNum -= 15;}
                array[rowI].netstarStyleObj = {
                    'padding-left': leftNum + 'px',
                };


                if (levelIndex > 0) {

                } else {
                    if (!isChildren) {
                    } else {
                        array[rowI].netstarOpen = isOpen;
                    }
                }
                treeRows.push(array[rowI]);
                let nIndex:number = array[rowI].netstarLevel + 1;
                if (isChildren) {
                    array[rowI].isParent = true;
                    formatTreeData(array[rowI].children,nIndex,true,rowI);
                } else {
                    array[rowI].isParent = false;
                }
            }
        }
        formatTreeData(rows, 0, false);
        return treeRows;
    }
    export function getResultByExpresstion(validData: any, validExpression: string){
        let rulesPatt:any = new RegExp("\{(.*?)\}", "g");
        let expressionStr:any = validExpression;
        let result:any;
        while ((result = rulesPatt.exec(validExpression)) != null) {
            let vofieldExpStr:string = result[1];  //vo.name
            let voFieldExpArr:any = vofieldExpStr.split('.');
            let voFieldValue:any = validData;
            for (let vfI = 0; vfI < voFieldExpArr.length; vfI++) {
                if (typeof (voFieldValue[voFieldExpArr[vfI]]) != 'undefined') {
                    //逐层从validData中读取值
                    voFieldValue = voFieldValue[voFieldExpArr[vfI]];
                } else {
                    // 根据验证规则表达式 rules 获取值失败 直接退出
                    // 如果是空值默认为0
                    voFieldValue = null;
                }
            }
            // 判断是否为负值,如果为负值的话(1--1)这种情况下eval会有问题,只要有负数就加括号
            if(typeof(voFieldValue) == "number" && voFieldValue < 0) {
                voFieldValue = "(" + voFieldValue + ")";
            }else if(voFieldValue === ""){
                voFieldValue = '""';
            }
            expressionStr = expressionStr.replace(result[0], voFieldValue);
        }   
        let funcStr = 'function(){'
                            + 'return ' + expressionStr + ';'
                        + '}'
        let func: any = window.NSUtils.getFunction(funcStr);
        let resVal = false;
        try {
            resVal = func();
        } catch (error) {
            console.log(error);
        }
        return resVal;
    }
    /**
     * 对象转换 {a:"1", b:"2"} -> a=1&b=2
     * @param  {object} data 要转换的对象
    */
    export function objectConver(data: any){
        let str = '';
        let arr: Array<string> = [];
        for(let key in data){
            arr.push(key + '=' + data[key]);
        }
        str = arr.join('&');
        return str;
    }
    /**
     * 掩码转换
     * @param  {string} str 要转换的字符 如13289873029
     * @param  {number} frontLen 起始位置 如4
     * @param  {number} endLen  结束位置 如4
     * @param  {string} replaceVal 要替换的字符 如 *   最终输出132****029
    */
    export function maskConver(str:string,frontLen:number,endLen:number,replaceVal:string){
        if(typeof(str)!='string'){
            return str;
        }
        if(typeof(frontLen)!='number' || typeof(endLen)!='number'){
            return str;
        }
        var len = str.length-frontLen-endLen;
        var xing = '';
        for (var i=0;i<len;i++) {
            xing+=replaceVal;
        }
        return str.substring(0,frontLen)+xing+str.substring(str.length-endLen);
    }
    export function getDataForLogRecord(fieldArray:any,serverData:any,pageData:any){
        //["name","xinming", "laowang",'laoliu'] 对应的配置["key","label","originalValue","newValue"]
        let resultData:any = [];
        serverData = typeof(serverData)=='object' ? serverData : {};
        pageData = typeof(pageData)=='object' ? pageData : {};
        for(let fieldI=0; fieldI<fieldArray.length; fieldI++){
            const fieldData:any = fieldArray[fieldI];
            let fieldServerData:any = serverData[fieldData.id];
            if(typeof(fieldServerData)=='undefined'){fieldServerData = '';}
            let fieldPageData:any = pageData[fieldData.id];
            if(typeof(fieldPageData)=='undefined'){fieldPageData = '';}
            let isPush:boolean = true;
            if((fieldServerData == fieldPageData) && pageData.id){
                isPush = false;//值一样不存储
            }
            if(typeof(fieldServerData)=='number' && typeof(fieldPageData)=='string'){
                if((Number(fieldPageData) === fieldServerData) && pageData.id){
                    isPush = false; //结果相等不存储
                }
            }
            if(pageData.objectState == -1){
                isPush = true;//删除的数据
            }
            if(isPush === true){
                const saveIdFieldStr = fieldData.targetSaveId ? fieldData.targetSaveId : fieldData.id;
                const tempArray:any = [saveIdFieldStr,fieldData.label,fieldServerData,fieldPageData,pageData.objectState];
                resultData.push(tempArray);
                if(typeof(fieldData.outputFields)=='object'){
                    for(let outFieldI in fieldData.outputFields){
                        let oldVal = typeof(serverData[outFieldI])=='undefined' ? '' : serverData[outFieldI];
                        if(oldVal == null){oldVal = '';}
                        let newVal = typeof(pageData[outFieldI])=='undefined' ? '' : pageData[outFieldI];
                        if(newVal == null){newVal = '';}
                        if(fieldData.outputFields[outFieldI] === '{'+fieldData.textField+'}' && Array.isArray(fieldData.subdata) && fieldServerData){
                            for(let fI=0; fI<fieldData.subdata.length; fI++){
                                if(fieldData.subdata[fI][fieldData.valueField] == fieldServerData){
                                    oldVal = fieldData.subdata[fI][fieldData.textField] ? fieldData.subdata[fI][fieldData.textField] : '';
                                    break;
                                }
                            }
                        }
                        //修改的时候需要判断值是否相等
                        let isPushOutField = true;
                        if(pageData.objectState == 2 && oldVal == newVal){ isPushOutField = false;}
                        if(isPushOutField == true){
                            const tempArray:any = [outFieldI,fieldData.label,oldVal,newVal,pageData.objectState];
                            resultData.push(tempArray);
                        }
                    }
                }
            }
        }
        return resultData;
    }//依据配置的field字段 输出当前具体组件的值是修改还是新增
    /**
     * 获取模板的日志信息
     */
    export function getLogContentByTemplate(config,serverData,pageData){
        let logVoData:any = {
            vo:[]
        };
        for(let c=0; c<config.components.length; c++){
            const componentData = config.components[c];
            const cKeyFieldStr = componentData.keyField ? componentData.keyField : 'root';
            switch(componentData.type){
               case 'vo':
                    const tempLogData = window.NSUtils.valueConvertManager.getDataForLogRecord(componentData.field,serverData,pageData);
                    for(let t=0; t<tempLogData.length; t++){
                        logVoData.vo.push(tempLogData[t]);
                    }
                    break;
                case 'list':
                    if(Array.isArray(pageData[cKeyFieldStr])){
                        if(pageData[cKeyFieldStr].length > 0){
                            let listTitleStr = componentData.title ? componentData.title : '';
                            for(let listI=0; listI<pageData[cKeyFieldStr].length; listI++){
                                const serverRowData = serverData[cKeyFieldStr] && serverData[cKeyFieldStr][listI] ? serverData[cKeyFieldStr][listI] : {};
                                const pageRowData = pageData[cKeyFieldStr][listI];
                                if(typeof(serverRowData)=='object' && typeof(pageRowData)=='object'){
                                    let listLogFieldArr = [];
                                    for(let fieldI=0; fieldI<componentData.field.length; fieldI++){
                                        const tFieldConfig = componentData.field[fieldI];
                                        let tSubdataArray = [];
                                        let tFieldType = 'text';
                                        let tTextField = '';
                                        let tValueField = '';
                                        if(typeof(tFieldConfig.editConfig)=='object'){
                                            if(Array.isArray(tFieldConfig.editConfig.subdata)){
                                                tSubdataArray = tFieldConfig.editConfig.subdata;
                                            }
                                            tTextField = tFieldConfig.editConfig.textField;
                                            tValueField = tFieldConfig.editConfig.valueField;
                                        }
                                        if(tFieldConfig.hidden !== true){
                                            listLogFieldArr.push({
                                                id:tFieldConfig.field,
                                                targetSaveId:cKeyFieldStr+'.'+tFieldConfig.field,
                                                label:listTitleStr+'.'+(listI+1)+'.'+tFieldConfig.title,
                                                subdata:tSubdataArray,
                                                type:tFieldType,
                                                textField:tTextField,
                                                valueField:tValueField
                                            });
                                        }
                                    }
                                    let rowLogData = window.NSUtils.valueConvertManager.getDataForLogRecord(listLogFieldArr,serverRowData,pageRowData);
                                    for(let t=0; t<rowLogData.length; t++){
                                        logVoData.vo.push(rowLogData[t]);
                                    }
                                }
                            }
                        }
                    }
                    break;
                default:
                    break;
            }
        }
        return logVoData;
    }
}
export default valueConverManager;